type OptionalText = string | null | undefined;

interface AddressFields {
  street?: OptionalText;
  houseNumber?: OptionalText;
  postalCode?: OptionalText;
  city?: OptionalText;
}

export function formatMunicipalPropertyAddress({ street, houseNumber, postalCode, city }: AddressFields): string {
  const streetLine = [street, houseNumber].filter(Boolean).join(" ");
  const cityLine = [postalCode, city].filter(Boolean).join(" ");
  return [streetLine, cityLine].filter(Boolean).join(", ");
}
